import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["publishButton", "publishButtonSpinner", "publishButtonText"]

  publish(event) {
    // Show loading state
    this.setPublishButtonLoading(true)

    // Let the form submit naturally
    return true
  }

  setPublishButtonLoading(loading) {
    if (!this.hasPublishButtonTarget) return

    if (loading) {
      this.publishButtonTarget.disabled = true
      this.publishButtonTarget.classList.add('opacity-75', 'cursor-not-allowed')
      this.publishButtonTarget.classList.remove('hover:bg-green-700', 'cursor-pointer')

      if (this.hasPublishButtonSpinnerTarget) {
        this.publishButtonSpinnerTarget.classList.remove('hidden')
      }

      if (this.hasPublishButtonTextTarget) {
        this.publishButtonTextTarget.textContent = 'Publishing...'
      }
    } else {
      this.publishButtonTarget.disabled = false
      this.publishButtonTarget.classList.remove('opacity-75', 'cursor-not-allowed')
      this.publishButtonTarget.classList.add('hover:bg-green-700', 'cursor-pointer')

      if (this.hasPublishButtonSpinnerTarget) {
        this.publishButtonSpinnerTarget.classList.add('hidden')
      }

      if (this.hasPublishButtonTextTarget) {
        this.publishButtonTextTarget.textContent = 'PUBLISH THE ALBUM →'
      }
    }
  }
}
